//JavaScript Document
import * as TYPE from "../mutation-types";

export default {
	namespaced: true,
	state: {
		workspace: new Object()
	},
	mutations: {
		[TYPE.SET_WORKSPACE](state, payload) {
			state.workspace = payload;
		}
	},
	actions: {
		setWorkspace({commit}, payload) {
			commit(TYPE.SET_WORKSPACE, payload);
		}
	}
};
